export var InteractiveBoardRoutes;
(function (InteractiveBoardRoutes) {
    InteractiveBoardRoutes["main"] = "/interactive-board";
})(InteractiveBoardRoutes || (InteractiveBoardRoutes = {}));
export const interactive_board_routes = (children) => ({
    path: InteractiveBoardRoutes.main,
    element: children,
    children: [{ path: `${InteractiveBoardRoutes.main}/:id`, element: children }],
});
